import React from "react";
import { inject, observer } from "mobx-react";
import { formatMoney, formatNumber } from "accounting";
import RepaymentStore from "../../stores/RepaymentStore";

import {
  RepaymentsDisclaimer1,
  RepaymentsDisclaimer2,
  RepaymentsDisclaimer4,
  RepaymentsDisclaimerForComparisonRate,
} from "./RepaymentDisclaimers";

interface State {}

interface Props {
  pimIdentifier: string;
  rdp: number;
}
interface InjectedProps extends Props {
  repaymentStore: RepaymentStore;
}

@inject("repaymentStore")
@observer
class Repayment extends React.Component<Props, State> {
  financeSettingsLinkRef: any;
  setFinanceSettingsLinkRef: any;
  constructor(props: Props) {
    super(props);
  }

  get injected() {
    return this.props as InjectedProps;
  }

  render() {
    const { pimIdentifier, rdp } = this.props;
    const { repaymentStore } = this.injected;
    const index = repaymentStore.variants.findIndex(
      (x) => (x != null && x.pimIdentifier) == pimIdentifier
    );
    return !repaymentStore.isLoading[index] ? (
      <div className="modelWalk__finance">
        <hr />
        {!(
          repaymentStore.isGfvError[index] ||
          repaymentStore.isDepositTooHighError[index] ||
          repaymentStore.isGeneralError[index]
        ) ? (
          <div className="modelWalk__finance_value-flex-container">
            <div className="modelWalk__finance_payment-value">
              <div>
                <div>
                  <span className="modelWalk__finance-from">From</span>
                  <div
                    className="modelWalk__finance_payment-value-line-one"
                    onClick={(e) => {
                      e.preventDefault();
                      repaymentStore.showDisclaimer(
                        RepaymentsDisclaimer2(
                          formatMoney(rdp, {
                            symbol: "$",
                            precision: 0,
                          }),
                          repaymentStore.loanTerm,
                          repaymentStore.interestRates[index],
                          formatMoney(repaymentStore.deposits[index], {
                            symbol: "$",
                            precision: 2,
                          }),
                          repaymentStore.paymentFrequency,
                          repaymentStore.monthlyRepayments[index],
                          repaymentStore.financeProductId ===
                            "FIN_PROD_AUS_SUB_GFV",
                          formatNumber(repaymentStore.mileage[index]),
                          formatMoney(repaymentStore.residualValues[index])
                        )
                      );
                    }}
                  >
                    {formatMoney(repaymentStore.paymentValues[index], {
                      symbol: "$",
                      precision: 0,
                    })}{" "}
                    p/{repaymentStore.paymentFrequencyString}
                    <sup>2</sup>
                  </div>
                </div>
                <div className="modelWalk__finance_payment-value-line-two">
                  {repaymentStore.residualValues[index] > 0 && (
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        repaymentStore.showDisclaimer(RepaymentsDisclaimer1());
                      }}
                    >
                      with Subaru GFV<sup>1</sup>
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="modelWalk__finance_comparison-rate">
              <div
                className="modelWalk__finance_comparison-rate-line-one"
                onClick={(e) => {
                  e.preventDefault();
                  repaymentStore.showDisclaimer(
                    RepaymentsDisclaimer4(
                      repaymentStore.isFinanceFormInputPersonalised
                    )
                  );
                }}
              >
                {repaymentStore.comparisonRates[index]}% p.a.<sup>4</sup>
              </div>
              <div
                className="modelWalk__finance_comparison-rate-line-two"
                onClick={(e) => {
                  e.preventDefault();
                  repaymentStore.showDisclaimer(
                    RepaymentsDisclaimerForComparisonRate()
                  );
                }}
              >
                Comparison rate
                <i className="icon icon--info" />
              </div>
            </div>
          </div>
        ) : (
          <div className="modelWalk__finance_payment-value-line-two">
            {repaymentStore.errorMessage[index]}
          </div>
        )}
        <hr />
        {
          <div className="modelWalk__priceDisclaimer modelWalk__priceDisclaimer--full">
            Recommended Driveaway Price (RDP)&nbsp;
            {`${
              repaymentStore.suburb
                ? `shown based on ${repaymentStore.suburb.name}, ${repaymentStore.suburb.postcode}`
                : ""
            }`}
            . RDP may change based on location.&nbsp;
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault();
                repaymentStore.showPostcodeOverlayActive();
              }}
            >
              Enter your postcode&nbsp;
            </a>
            for the RDP in your area.
          </div>
        }
        <div className="modelWalk__finance_disclaimer">
          {!(
            repaymentStore.isGfvError[index] ||
            repaymentStore.isDepositTooHighError[index] ||
            repaymentStore.isGeneralError[index]
          ) && (
            <div>
              Estimated repayments based on a deposit of{" "}
              {formatMoney(repaymentStore.deposits[index], {
                symbol: "$",
                precision: 0,
              })}{" "}
              over a {repaymentStore.loanTerm} month term
              {repaymentStore.financeProductId === "FIN_PROD_AUS_SUB_GFV" &&
              repaymentStore.residualValues[index] > 1 ? (
                <span>
                  {" "}
                  with a Guaranteed Future Value of{" "}
                  {formatMoney(repaymentStore.residualValues[index], {
                    symbol: "$",
                    precision: 0,
                  })}{" "}
                  with an annual km allowance of{" "}
                  {formatNumber(repaymentStore.mileage[index])}.{" "}
                </span>
              ) : (
                ". "
              )}
            </div>
          )}
          <a
            onClick={(e) => {
              e.preventDefault();
              repaymentStore.showFinanceSettingsModal(pimIdentifier);
            }}
          >
            <i className="icon icon--pencil" />
            {repaymentStore.isFinanceFormInputPersonalised
              ? "Edit finance settings"
              : "Personalise finance settings"}
          </a>
        </div>
      </div>
    ) : (
      <div className="modelWalk__finance inlineLoader inlineLoader--loading">
        <span className="inlineLoader__loader" />
      </div>
    );
  }
}

export default Repayment;
